import script from "./AssessmentStepsAndLinksConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentStepsAndLinksConfig.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentStepsAndLinksConfig.vue?vue&type=style&index=0&id=714748df&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714748df"]])

export default __exports__